export default {
  etzProfile: 'ETZ Profile',
  employers: 'Employers',
  iraAccounts: 'IRA Accounts',
  contributions: 'Contributions',
  settings: 'Settings',
};
